import { IConfigService } from './configServiceTypes';

export class ConfigServiceStub implements IConfigService {
	public isDevelopment(): boolean {
		return !(window as any).mp;
	}

	public isStub(): boolean {
		return true;
	}

	public getBackendUrl(): string {
		return 'http://localhost:3000';
	}
}
